// extracted by mini-css-extract-plugin
export default {"cardSection":"CardContainer_cardSection__ql9uq","loadingHeading":"CardContainer_loadingHeading__BiTPg","errorPara":"CardContainer_errorPara__hOtEw"};